import { BdsTable, BdsTableCell } from 'blip-ds/dist/blip-ds-react';
import styled from 'styled-components';

import colors from '_colors.module.scss';

export const TABLE_ROW_HEIGHT_PX = 64;
export const TABLE_HEADER_HEIGHT_PX = 65;

export const TableContainer = styled.div<{ shouldHideBorderBottom?: boolean; minHeight?: string }>`
  ${(props) => props.shouldHideBorderBottom && 'border-bottom: none;'};
  /*
   * overflow must stay "visible" so absolutely positioned content inside
   * rows (e.g. BdsDropdown action menus in the last column) can escape
   * the table bounds and render above sibling components.
   */
  overflow: visible;
  width: 100%;
  ${(props) => props.minHeight && `min-height: ${props.minHeight};`};
  overflow-anchor: none;
  transition: min-height 0.3s ease-in-out;
`;

export const Table = styled(BdsTable)<{ backgroundColor?: string }>`
  display: flex;
  width: 100%;
  
  background-color: ${(props) => props.backgroundColor ?? colors.Surface0};
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-color: ${colors.Border2};

  .sc-bds-table-h {
    border-radius: none;
  }

  & > .sc-bds-table-h {
    border-radius: none;
  }

  & .bds-table {
    table-layout: fixed;
    width: 100%;
  }

  bds-table-th,
  bds-table-th .th_cell,
  bds-table-th bds-typo {
    cursor: default !important;
  }

  bds-table-th {
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  bds-table-cell .cell {
    flex-wrap: nowrap !important;
    min-width: 0;
    min-height: 64px;
    margin: 0;
  }
`;

export const SkeletonTableCell = styled(BdsTableCell)`
  bds-typo {
    width: 100%;
  }
`;

export const StateContent = styled.td`
  height: 20rem;
  align-content: center;
`;

export const SortHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.7;

    .sort-arrow-inactive {
      opacity: 0.7;
    }
  }

  .sort-arrow-inactive {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
`;

export const PaginationRow = styled.div<{ backgroundColor?: string }>`
  display: flex;
  padding: 1.5rem 1rem;
  align-items: center;
  background-color: ${(props) => props.backgroundColor ?? colors.Surface0};
  border: 1px solid ${colors.Border2};
  border-top: none;
  border-radius: 0 0 1rem 1rem;
`;
